import { useEffect } from 'react';
import { Loader } from '../../common/components/Loader';
import { useGetQueryParam } from '../../common/hooks';

export const SocialAuthHelper = () => {
  const microsoftCodeQueryParam = useGetQueryParam('code');

  useEffect(() => {
    if (microsoftCodeQueryParam) {
      window.opener.parent.postMessage({ code: microsoftCodeQueryParam });
    } else {
      window.opener.parent.postMessage({ error: 'Microsoft login failed' });
    }

    window.close();
  }, [microsoftCodeQueryParam]);

  return <Loader />;
};
